import Component from '../core/Component'

export const STATES = {
    ACTIVE: 'is-active',
}

export default class SingleActiveToggle extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            items: [],
        }
    }

    prepare() {
        this.ref.items.forEach(item => item.addEventListener('click', this.handleToggleClick))
    }

    destroy() {
        this.ref.items.forEach(item => item.removeEventListener('click', this.handleToggleClick))
    }

    handleToggleClick = event => {
        event.preventDefault()
        const index = this.ref.items.indexOf(event.currentTarget)
        this.toggle(index)
    }

    toggle(itemIndex) {
        const item = this.ref.items[itemIndex]

        if (item.classList.contains(STATES.ACTIVE)) {
            item.classList.remove(STATES.ACTIVE)
        } else {
            this.ref.items.forEach(item => {
                item.classList.remove(STATES.ACTIVE)
            })
            item.classList.add(STATES.ACTIVE)
        }
    }
}
